import { api } from "@/frontend/services/api";
import type {
  RegisterRequestDTO,
  UserResponseDTO,
  UsersPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/users/private";
export const userService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<UsersPaginatedResponseDTO>>(
      BASE_URL,
      params
    );
  },
  getAll: () =>
    api.get<ApiResponse<UserResponseDTO[]>>(`${BASE_URL}/all`),
  getById: (id?: string) =>
    api.get<ApiResponse<UserResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: RegisterRequestDTO) =>
    api.post<ApiResponse<UserResponseDTO>>(BASE_URL, data),
  update: (id: string, data: Partial<RegisterRequestDTO>) =>
    api.put<ApiResponse<UserResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
